module.exports = __webpack_public_path__ + "img/right.fa25b916.png";